import { render, staticRenderFns } from "./MultipleDestinations.vue?vue&type=template&id=67f66dde&scoped=true&"
import script from "./MultipleDestinations.vue?vue&type=script&lang=js&"
export * from "./MultipleDestinations.vue?vue&type=script&lang=js&"
import style0 from "./MultipleDestinations.vue?vue&type=style&index=0&id=67f66dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f66dde",
  null
  
)

export default component.exports